import { useIO, useModel } from "@type-r/react";
import { Loading, Page } from "lqx-react";
import React, { useEffect, useMemo } from "react";
import { BoundPolicy, BoundPolicyBuyer } from "../api/boundPolicy";
import { BoundPolicySummary } from "./bound-policy-summary";
import { BoundPolicyBuyers } from "./bound-policy-buyers";
import { PolicyApprovedLimits } from "../api/policyApprovedLimit";

const useBuyers = (buyers: BoundPolicyBuyer[], condition: (d: BoundPolicyBuyer) => Boolean, changeToken) => {
    return useMemo(() => {
        const unique = new Set();
        return buyers ? buyers.filter(buyer => {
            if(unique.has(buyer.id)){
                return false;
            }
            const result = condition(buyer);
            if(result){
                unique.add(buyer.id);
            }
            return result;
        }) : []
    }, changeToken);
}

export const LinkPolicyToInvoices = ({ policyId }) => {
    const policy = useModel(BoundPolicy);
    const policyApprovedLitmits = useModel(PolicyApprovedLimits);
    const isPolicyReady = useIO(async () => {
        policy.id = policyId;
        policyApprovedLitmits.policyId = policyId;
        await policy.fetch();
    });

    const isApprovedLimitsReady = useIO(async () => await policyApprovedLitmits.approvedLimits.fetch(), [ true ]);
    useEffect(() =>policyApprovedLitmits.approvedLimits.forEach(l => l.assignBuyers()), [policyApprovedLitmits.approvedLimits[ '_changeToken' ] ]);

    const allBuyers = useMemo(() => {
        var result = [];
        policyApprovedLitmits.approvedLimits.models.forEach(al => al.debtors.forEach(d => result.push(d)));
        return result;
    }, [policyApprovedLitmits.approvedLimits[ '_changeToken' ] ]);

    const buyersHavingLimitInThisPolicy = useBuyers(allBuyers, d => d.policyId == policyId, [ policyApprovedLitmits.approvedLimits[ '_changeToken' ] ]);
    const buyersHavingLimitInThisAndAnotherPolicy = useBuyers(allBuyers, d => {
        return buyersHavingLimitInThisPolicy.filter(pd => pd.id == d.id).length > 0 &&
            allBuyers.filter(ad => ad.id == d.id && ad.policyId != policyId).length > 0;
    }, [ policyApprovedLitmits.approvedLimits[ '_changeToken' ] ]);
    const buyersNotHavingLimitInThisPolicy = useBuyers(allBuyers, d => false, [ policyApprovedLitmits.approvedLimits[ '_changeToken' ] ]);

    return !isPolicyReady || !isApprovedLimitsReady ? <Loading /> :
        <Page header={
            <BoundPolicySummary policy={ policy }  policyApprovedLimits ={ policyApprovedLitmits } />
        }>
            <BoundPolicyBuyers title={ `Invoices that are related to debtor that have a limit in this policy (${buyersHavingLimitInThisPolicy.length})` } buyers={ buyersHavingLimitInThisPolicy } />
            <BoundPolicyBuyers title={ `Invoices that are related to debtor that have a limit in this policy and another policy (${buyersHavingLimitInThisAndAnotherPolicy.length})` } buyers={ buyersHavingLimitInThisAndAnotherPolicy } />
            <BoundPolicyBuyers title={ `Invoices that are related to debtor and don't have a limit in this policy (${buyersNotHavingLimitInThisPolicy.length})` } buyers={ buyersNotHavingLimitInThisPolicy } />
        </Page>
};
